import clsx from 'clsx';
import { AntButton } from 'components/ant/AntButton/AntButton';
import React from 'react';

import s from './LinkLike.module.less';

interface Props extends React.ComponentProps<typeof AntButton> {
  children?: React.ReactNode;
  semibold?: boolean;
  disabled?: boolean;
  fontSize?: number;
}

export const LinkLike = React.forwardRef<HTMLButtonElement, Props>((props, ref) => {
  const { children, semibold, disabled, fontSize, ...rest } = props;

  const className = clsx(s.root, props.className, {
    [s.semibold]: semibold,
    [s.disabled]: disabled,
  });

  const style = fontSize ? { fontSize: `${fontSize}px`, ...props.style } : props.style;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();

    if (disabled) return;

    props.onClick?.(e);
  };

  return (
    <AntButton ref={ref} type="link" size="small" {...rest} className={className} style={style} onClick={handleClick}>
      {children}
    </AntButton>
  );
});

LinkLike.displayName = 'LinkLike';
